import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { InventoryByTransactionType } from "@/graphql/codegen/graphql"

interface ProductInventoryTransactionTypeCellProps {
  type?: InventoryByTransactionType | null
}

const TYPE_TO_LABEL: Record<InventoryByTransactionType, string> = {
  [InventoryByTransactionType.Po]: "PO",
  [InventoryByTransactionType.So]: "SO",
  [InventoryByTransactionType.Inv]: "INV",
} as const

const TYPE_TO_CLASS_NAME: Record<InventoryByTransactionType, string> = {
  [InventoryByTransactionType.Po]: "bg-tertiary-green-100",
  [InventoryByTransactionType.So]: "bg-primary-200",
  [InventoryByTransactionType.Inv]: "bg-gray-300",
} as const

export const ProductInventoryTransactionTypeCell: FC<ProductInventoryTransactionTypeCellProps> = ({ type }) => {
  if (!type) return null

  return <Chip className={twMerge("h-6 rounded text-xs", TYPE_TO_CLASS_NAME[type])} label={TYPE_TO_LABEL[type]} />
}
